/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ns = "[Blueprint]";
var deprec = ns + " DEPRECATION:";
exports.POPOVER2_WARN_DEPRECATED_IS_DISABLED = deprec + " <Popover2> isDisabled is deprecated. Use disabled.";
exports.POPOVER2_WARN_DEPRECATED_IS_MODAL = deprec + " <Popover2> isModal is deprecated. Use hasBackdrop.";
exports.POPOVER2_WARN_DEPRECATED_POSITION = deprec + " <Popover2> position is deprecated. Use placement.";

//# sourceMappingURL=errors.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@blueprintjs/labs/dist/common/errors.js
// module id = 880
// module chunks = 0